import React from 'react'
import {Col, Container, Row} from 'react-bootstrap'

const Footer = () => {
    return (
        <footer className="d-print-none">
            <Container>
                <Row>
                    <Col className="text-center py-3">
                        Copyright &copy; <em>Aprendiz do Sucesso</em>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
